import React from 'react';
import { ActionType } from 'types/entities/admin-activity-logs';
import { TAdminActivityLogListFilters } from '../pages/admin-activity-log-list/admin-activity-log-list';
import { Formik } from 'formik';
import ButtonFilterApply from '../../transactions-history/components/button-filter-apply';
import ButtonFilterClear from '../../transactions-history/components/button-filter-clear';
import { Col } from 'components/layout/layout';
import AppFormikInput from 'components/form/formik/input/input';
import { EErrorPos, ELabelPos } from '../../ekyc/components/form/formik/types';
import Select from 'components/form/select';
import { toSentenceCaseFormat } from 'utils/sentence-case-format';

interface IAdminActivityLogListFiltersProps {
    onFiltersChange: (filters: TAdminActivityLogListFilters) => void;
    currentFilters: TAdminActivityLogListFilters;
    defaultFilters: TAdminActivityLogListFilters;
}

const AdminActivityLogListFilters: React.FC<
    IAdminActivityLogListFiltersProps
> = ({ onFiltersChange, currentFilters, defaultFilters }) => {
    const actionTypeOptions = Object.entries(ActionType).map(
        ([key, value]) => ({
            key,
            value: toSentenceCaseFormat(value),
        }),
    );
    const handleResetFilters = () => {
        onFiltersChange(defaultFilters);
    };

    return (
        <Formik
            enableReinitialize={true}
            initialValues={currentFilters}
            onSubmit={(values) => {
                onFiltersChange(values);
            }}
            // validate={(values) => {
            //     let errors: Partial<TFilterValues> = {};

            //     if (!values.dateFrom && values.dateTo) {
            //         errors.dateFrom = 'Required if "To date" selected';
            //     }

            //     if (values.dateFrom && !values.dateTo) {
            //         errors.dateTo = 'Required if "From date" selected';
            //     }

            //     return errors;
            // }}
        >
            <Col align={'bottom'} justify={'start'}>
                <AppFormikInput
                    id={'nexId'}
                    labelPos={ELabelPos.top}
                    errorPos={EErrorPos.bottom}
                    label={'User Nex ID'}
                    name={'nexId'}
                    inputProps={{ type: 'text' }}
                />
                <AppFormikInput
                    id={'adminEmail'}
                    labelPos={ELabelPos.top}
                    errorPos={EErrorPos.bottom}
                    label={'Admin Email'}
                    name={'adminEmail'}
                    inputProps={{ type: 'text' }}
                />
                <AppFormikInput
                    id={'startDate'}
                    label={'Date from'}
                    errorPos={EErrorPos.bottom}
                    labelPos={ELabelPos.top}
                    name={'startDate'}
                    inputProps={{ type: 'date' }}
                />
                <AppFormikInput
                    id={'endDate'}
                    labelPos={ELabelPos.top}
                    errorPos={EErrorPos.bottom}
                    label={'Date to'}
                    name={'endDate'}
                    inputProps={{ type: 'date' }}
                />
                <Select
                    options={actionTypeOptions}
                    value={currentFilters.actionType}
                    label={'Action Type'}
                    onChange={(e: any) => {
                        onFiltersChange({
                            ...currentFilters,
                            actionType: e.target.value,
                        });
                    }}
                />

                <ButtonFilterApply label={'Apply'} />
                <ButtonFilterClear
                    label={'Clear'}
                    onClear={handleResetFilters}
                />
            </Col>
        </Formik>
    );
};

export default AdminActivityLogListFilters;
